import { QueryList } from '@angular/core';
import { Reminder } from '../../shared/models/Reminder';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material';
import { ReminderService } from '../../shared/services/reminder.service';
import { Subject } from 'rxjs';
import { AchievementService } from 'app/shared/services/achievement.service';
var NotificationComponent = (function () {
    function NotificationComponent(reminderService, translate, snackBar, achivementService) {
        var _this = this;
        this.reminderService = reminderService;
        this.translate = translate;
        this.snackBar = snackBar;
        this.achivementService = achivementService;
        this.ngUnsubscribe = new Subject();
        this.defaultReminder = null;
        this.myNotifications = [];
        this.newNotification = new Reminder();
        this.date = new Date();
        this.isPaused = false;
        this.pauseRange = {
            beginDate: { day: this.date.getDate(), month: this.date.getMonth() + 1, year: this.date.getFullYear() },
            endDate: { day: this.date.getDate(), month: this.date.getMonth() + 1, year: this.date.getFullYear() },
        };
        reminderService.getMyReminders().then(function (response) {
            _this.defaultReminder = response.defaultReminder;
            _this.myNotifications = response.reminders;
        });
        reminderService.getReminderPause().then(function (pause) {
            _this.isPaused = pause.isPaused || false;
            _this.pauseRange = pause.dateRange ? pause.dateRange : _this.pauseRange;
        });
    }
    NotificationComponent.prototype.onDateRangeChanged = function (event) {
        // event equals the structure of the pauseRange object
        this.pauseRange = event;
        this.savePause();
    };
    NotificationComponent.prototype.togglePause = function (e) {
        this.isPaused = e.checked;
        if ((this.pauseRange && this.pauseRange.beginDate && this.pauseRange.endDate) || !this.isPaused) {
            this.savePause();
            this.achivementService.updateAchievementForUser('Holiday');
        }
    };
    NotificationComponent.prototype.savePause = function () {
        var _this = this;
        this.reminderService
            .setReminderPause(this.isPaused, this.pauseRange)
            .then(function (result) {
            _this.translate
                .get('REMINDER.ALERT.savePauseSuccess')
                .takeUntil(_this.ngUnsubscribe)
                .subscribe(function (message) {
                _this.snackBar.open(message, null, {
                    verticalPosition: 'bottom',
                    duration: 4000,
                    panelClass: ['b2a-success', 'bottom'],
                });
            });
        })
            .catch(function (error) {
            _this.translate
                .get('REMINDER.ALERT.savePauseError')
                .takeUntil(_this.ngUnsubscribe)
                .subscribe(function (message) {
                _this.snackBar.open(message, null, {
                    verticalPosition: 'bottom',
                    duration: 4000,
                    panelClass: ['b2a-error', 'bottom'],
                });
            });
        });
    };
    NotificationComponent.prototype.addBox = function (sender) {
        var _this = this;
        this.reminderService
            .saveNewReminder(sender.reminder)
            .then(function (response) {
            _this.defaultReminder = response.defaultReminder;
            _this.myNotifications = response.reminders;
            _this.newNotification = new Reminder();
            sender.reset();
        })
            .catch(function (error) {
            _this.translate
                .get('REMINDER.ALERT.addNewReminderError')
                .takeUntil(_this.ngUnsubscribe)
                .subscribe(function (message) {
                _this.snackBar.open(message, null, {
                    verticalPosition: 'bottom',
                    duration: 4000,
                    panelClass: ['b2a-error', 'bottom'],
                });
            });
        });
    };
    NotificationComponent.prototype.deleteBox = function (sender) {
        var _this = this;
        this.reminderService
            .deleteMyReminder(sender.reminder)
            .then(function (response) {
            _this.leaveEditMode(sender);
            _this.defaultReminder = response.defaultReminder;
            _this.myNotifications = response.reminders;
        })
            .catch(function (error) {
            _this.translate
                .get('REMINDER.ALERT.deleteReminderError')
                .takeUntil(_this.ngUnsubscribe)
                .subscribe(function (message) {
                _this.snackBar.open(message, null, {
                    verticalPosition: 'bottom',
                    duration: 4000,
                    panelClass: ['b2a-error', 'bottom'],
                });
            });
        });
    };
    NotificationComponent.prototype.enterEditMode = function (sender) {
        for (var _i = 0, _a = this.reminderBoxes.toArray(); _i < _a.length; _i++) {
            var box = _a[_i];
            if (box !== sender) {
                box.canEdit = false;
            }
        }
    };
    NotificationComponent.prototype.leaveEditMode = function (sender) {
        var _this = this;
        this.reminderService
            .updateMyReminder(sender.reminder)
            .then(function (result) {
            for (var _i = 0, _a = _this.reminderBoxes.toArray(); _i < _a.length; _i++) {
                var box = _a[_i];
                if (box !== sender) {
                    box.canEdit = true;
                }
            }
        })
            .catch(function (error) {
            _this.translate
                .get('REMINDER.ALERT.saveReminderError')
                .takeUntil(_this.ngUnsubscribe)
                .subscribe(function (message) {
                _this.snackBar.open(message, null, {
                    verticalPosition: 'bottom',
                    duration: 4000,
                    panelClass: ['b2a-error', 'bottom'],
                });
            });
        });
    };
    /**
     * On destroy cancel active subscriptions
     */
    NotificationComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return NotificationComponent;
}());
export { NotificationComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/notification/notification.component.ts.pre-build-optimizer.js